export const title = category => `Your ${category?.replace('care', '')} says keep going`;
export const body = category =>
  `Don’t give up on your perfectly customized routine—your ${category?.replace(
    'care',
    ''
  )} is counting on it.`;
export const continueCTA = "Let's keep customizing";
export const exitCTA = 'Nope, I’m gone';
